import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Table } from 'antd';
import { isEmpty, result } from 'lodash';
import { getGlobalSettings, genarateTableConfigs } from '../utils';
import { AssocCustomersPanel, AssocCustomerHeader } from './styled';
import {
  DEFAULT_CURRENT_PAGE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_WIDGET_TITLE,
  DEFAULT_MAP_NAMESPACE
} from './constants';
import ComponentsMap from '../ComponentsMap';

const { Panel } = Collapse;

const AlertAssocCustomers = ({
  apiActions,
  settings,
  gsQuery,
  alertId,
  assocCustomers,
  customerId,
  isLoading,
  error,
  mapNamespace = DEFAULT_MAP_NAMESPACE
}) => {
  const [currentPage, setCurrentPage] = useState(DEFAULT_CURRENT_PAGE);
  const [currentPageSize, setCurrentPageSize] = useState(DEFAULT_PAGE_SIZE);

  const { getAMLSCommonAlertAssocCustomers } = apiActions;
  const { widgetConfig, isVisible, widgetName } = getGlobalSettings({
    settings,
    gsQuery
  });

  useEffect(() => {
    if (!isEmpty(customerId) && isVisible) {
      getAMLSCommonAlertAssocCustomers({
        customerId,
        alertId,
        limit: currentPageSize,
        offset: (currentPage - 1) * currentPageSize
      });
    }
  }, [customerId]);

  const onPaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setCurrentPageSize(pageSize);
    getAMLSCommonAlertAssocCustomers({
      customerId,
      alertId,
      limit: pageSize,
      offset: (page - 1) * pageSize
    });
  };

  const { list = [], totalCount = 0 } = assocCustomers || {};

  const widgetTitle = widgetName
    ? `${widgetName} (${totalCount})`
    : `${DEFAULT_WIDGET_TITLE} (${totalCount})`;

  return (
    <>
      {isVisible && (
        <AssocCustomersPanel>
          <Collapse
            ghost
            bordered={false}
            defaultActiveKey={['1']}
            expandIconPosition="right">
            <Panel
              header={<AssocCustomerHeader>{widgetTitle}</AssocCustomerHeader>}
              key="1">
              <Table
                dataSource={list}
                columns={genarateTableConfigs({
                  settings: widgetConfig,
                  configs: result(ComponentsMap, mapNamespace) || {}
                })}
                rowKey="primaryPartyKey"
                loading={isLoading}
                pagination={{
                  total: totalCount,
                  current: currentPage,
                  onChange: onPaginationChange,
                  pageSize: currentPageSize,
                  showTotal: (total) => `${total} Records`,
                  showSizeChanger: false
                }}
              />
            </Panel>
          </Collapse>
        </AssocCustomersPanel>
      )}
      {error && null}
    </>
  );
};

AlertAssocCustomers.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  gsQuery: PropTypes.object.isRequired,
  alertId: PropTypes.string,
  customerId: PropTypes.string,
  assocCustomers: PropTypes.object,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  mapNamespace: PropTypes.string
};

export default AlertAssocCustomers;
